import { render, staticRenderFns } from "./KnowledgeHub.vue?vue&type=template&id=f40d1602&scoped=true&"
import script from "./KnowledgeHub.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeHub.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeHub.vue?vue&type=style&index=0&id=f40d1602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40d1602",
  null
  
)

export default component.exports